import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SendCheckboxStatusDataService {
  checkboxData$$ = new ReplaySubject<Array<string>>(1);
}
